import { calculateLocatinVars } from '../../../libs/browser';
import { reloadAccountProps } from '../../../libs/state';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommonIconButton from '../../../components/CommonIconButton';
import Context from '../../../provider';
import IconSuccess from '../../../assets/hkdc/icons/SuccessIcon';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import React, { useContext, useEffect } from 'react';
import config from '../../../config';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function MobileSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const notificationNotReadCount = useNotificationsCount();

  const { init, dispatch, me } = useContext(Context);

  useEffect(() => {
    checkAccountStatus();
  }, []);

  // This page only allow logged in user
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [init, me, navigate]);

  const checkAccountStatus = async () => {
    await reloadAccountProps({ dispatch });
  };

  const handleBackHome = () => {
    navigate(`${config.basename}`, { replace: true });
  };

  return (
    (
      <div className='mobile-success-page'>
        <div className="content-container">
          <div className="success-title-container">
            <div className="success-icon-cont">
              <IconSuccess
                className="setting-tag-icon"
                size="large" />
            </div>
              <div className="title-text-cont">
                <div className="title-text">
                {t(location.state.title)}
                </div>
              </div>
          </div>

          <div className="back-home-content-container">
            <div className='back-home-text'>
              {t(location.state.desc)}
            </div>
            <CommonIconButton
              text={t('success.back-btn')}
              endIcon= {<KeyboardArrowRightIcon />}
              btnBackgroundColor= "#004899"
              btnColor = "#ffffff"
              btnWidth= "14.8125rem"
              btnHeight= "2.375rem"
              onClick={handleBackHome}
            />
          </div>
        </div>
      </div>
    )
  );
}